import { ReactNode } from "react"

/**
 * The map's left button column. Several buttons only show on some maps or
 * for some accounts; stacking them keeps the column free of gaps. Each child
 * should be placed with `className="relative"` so its own menus still open
 * next to it.
 */
const MapButtonColumn = ({ children }: { children: ReactNode }) => (
  <div className="absolute left-[10px] top-[10px] z-10 flex flex-col gap-[5px]">
    {children}
  </div>
)

export default MapButtonColumn
